import * as yup from 'yup';

export const arrestFormValidation = yup.object().shape({
  // Tab 1: Administrative (mostly read-only, only date/time editable)
  arrestDate: yup.date().nullable(),

  // Tab 3: Arrest Information
  arrestType: yup.string().nullable(),
  arrestTypeCode: yup.string().nullable().optional(),

  arrestStatus: yup.string().nullable(),

  arrestLocation: yup.object().nullable().optional(),

  arrestingOfficer: yup.string().nullable(),

  bookingOfficer: yup.string().nullable().optional(),

  condition: yup.string().nullable().optional(),

  attitude: yup.string().nullable().optional(),

  medicalAttention: yup.string().nullable().optional(),

  injury: yup.string().nullable().optional(),

  drugsNarcotics: yup.string().nullable().optional(),

  bloodAlcoholLevel: yup.string().nullable().optional(),

  // Conditional: juvenileReleaseStatus required if arrestee is juvenile
  juvenileReleaseStatus: yup.string().nullable().optional(),

  // Multi-select for weapons
  arresteeWeapons: yup
    .array()
    .of(yup.string())
    .nullable()
    .optional()
    .max(2, 'Please select 2 items at maximum'),

  arrestLarcenyType: yup.string().nullable().optional(),

  // Co-defendants
  coDefendantsArrestNumber: yup.array().of(yup.string()).nullable().optional(),

  // NYS Arrest Report Fields
  statements: yup.string().nullable().optional(),

  idProcedure: yup.string().nullable().optional(),

  courtStatus: yup.string().nullable().optional(),

  miranda: yup.string().nullable().optional(),

  searchWarrant: yup.string().nullable().optional(),

  arraignmentJudge: yup.string().nullable().optional(),

  returnJudge: yup.string().nullable().optional(),

  notes: yup
    .string()
    .nullable()
    .optional()
    .max(2000, 'Notes must not exceed 2000 characters'),

  // Tab 7: Signatures and Verification
  arrestingOfficerSignature: yup.string().nullable().optional(),

  bookingOfficerSignature: yup.string().nullable().optional(),

  supervisorSignature: yup.string().nullable().optional(),

  arresteeSignature: yup.string().nullable().optional(),

  safisSubmitted: yup.boolean().default(false),
});

// Export inferred type from schema
export type ArrestFormSchema = yup.InferType<typeof arrestFormValidation>;
